import dishsData from './dishs.js'
import tipsData from './tips.js'

const shopData = {
    shopInfo: {
        shopTitle: "渔乡畅晚(光谷店)",
        shopAddress: "光谷步行街3号楼5楼520",
        shopTel: "023-87549630",
        shopDesc: "欢迎光临，本店所有食材均为当日采购，保证新鲜！快快享受新鲜美味的鱼火锅吧~~",
    },
    dishsData: dishsData,
    tipsData: tipsData,
    isCreated: false,
    isMounted: false
};

export default shopData



/** WEBPACK FOOTER **
 ** ./src/data/shopData.js
 **/